import React from 'react'
import ReactTable from 'react-table'
import { reduxForm, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
import { fetchDownPayment } from 'ducks/downPayment'
import { columns } from './data'
import { downPaymentDetailPath } from 'routes'
import { 
  MainBodyContent,
  SearchList,
  TablePagination 
} from 'components'
import { ProcurementContainer, ProcurementBody } from '../styled'

const DownPayment = (props) => {
  const { 
    listDownPayments, 
    loading,
    valueForm
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    props.fetchDownPayment({page:1,size:pageSize})
  },[])

  return (
    <MainBodyContent headerTitle='DownPayment'>
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList pageSize={pageSize} placeholder='Doc No., Title, Requester' fetchAPI={props.fetchDownPayment} formSearchName='formSearchDP' filterDate filterStatus/>
          <ReactTable
            columns={columns}
            data={Object.keys(listDownPayments).length>0?listDownPayments.data:[]}
            loading={loading}
            defaultPageSize={userPageSize}
            noDataText='No down payment data'
            previousText={<Icon name='arrow alternate circle left'/>}
            nextText={<Icon name='arrow alternate circle right'/>}
            className='downPaymentList'

            PaginationComponent={TablePagination}
            pages={Object.keys(listDownPayments).length>0?listDownPayments.totalPage:0}
            currentPage={Object.keys(listDownPayments).length>0?listDownPayments.page:0}
            onPageChange={(pageIndex) => {
              props.fetchDownPayment({...valueForm,page:pageIndex+1,size:pageSize})
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              setPageSize(pageSize)
              localStorage.setItem('userPageSize', pageSize)
              props.fetchDownPayment({...valueForm,page:pageIndex+1,size:pageSize})
            }}

            getTdProps={(state, rowInfo, column) => {
              return {
                onClick: (e, t) => {
                  if (rowInfo) window.open(downPaymentDetailPath(rowInfo.original.id))
                }
              }
            }}
          />
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  listDownPayments: state.downPayment.listDownPayments.data,
  loading: state.downPayment.listDownPayments.loading,
  valueForm: getFormValues('formSearchDP')(state)
})

const mapDispatchToProps = {
  fetchDownPayment
}

const contForm = reduxForm({
  form: 'formSearchDP',
  enableReinitialize: true,
})(DownPayment)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)